// extracted by mini-css-extract-plugin
export default {"container":"wr-z","brandName":"xr-z","productName":"yr-z","productNamePdpEnhancements":"zr-z","breakLongProductName":"Ar-z"};